import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=f5aae89a&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=f5aae89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aae89a",
  null
  
)

export default component.exports